export default __webpack_public_path__ + "static/media/grey-down-arrow.b53f95fa.svg";